import { SVGProps } from "react";

const Accounts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.0001 7.66C17.9401 7.65 17.8701 7.65 17.8101 7.66C16.4301 7.61 15.3301 6.48 15.3301 5.08C15.3301 3.65 16.4801 2.5 17.9101 2.5C19.3401 2.5 20.4901 3.66 20.4901 5.08C20.4801 6.48 19.3801 7.61 18.0001 7.66Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9695 14.9399C18.3395 15.1699 19.8495 14.9299 20.9095 14.2199C22.3195 13.2799 22.3195 11.7399 20.9095 10.7999C19.8395 10.0899 18.3095 9.84991 16.9395 10.0899"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.96852 7.66C6.02852 7.65 6.09852 7.65 6.15852 7.66C7.53852 7.61 8.63852 6.48 8.63852 5.08C8.63852 3.65 7.48852 2.5 6.05852 2.5C4.62852 2.5 3.47852 3.66 3.47852 5.08C3.48852 6.48 4.58852 7.61 5.96852 7.66Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.99945 14.9399C5.62945 15.1699 4.11945 14.9299 3.05945 14.2199C1.64945 13.2799 1.64945 11.7399 3.05945 10.7999C4.12945 10.0899 5.65945 9.84991 7.02945 10.0899"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0001 15.13C11.9401 15.12 11.8701 15.12 11.8101 15.13C10.4301 15.08 9.33008 13.95 9.33008 12.55C9.33008 11.12 10.4801 9.96997 11.9101 9.96997C13.3401 9.96997 14.4901 11.13 14.4901 12.55C14.4801 13.95 13.3801 15.09 12.0001 15.13Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.0907 18.2799C7.6807 19.2199 7.6807 20.7599 9.0907 21.6999C10.6907 22.7699 13.3107 22.7699 14.9107 21.6999C16.3207 20.7599 16.3207 19.2199 14.9107 18.2799C13.3207 17.2199 10.6907 17.2199 9.0907 18.2799Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Accounts;
